import { render, staticRenderFns } from "./AsyncSelector.vue?vue&type=template&id=628cd960"
import script from "./AsyncSelector.vue?vue&type=script&lang=js"
export * from "./AsyncSelector.vue?vue&type=script&lang=js"
import style0 from "./AsyncSelector.vue?vue&type=style&index=0&id=628cd960&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports